import React from 'react';
import {
  TrevorComponent,
  TrevorIcon,
  useDropdown,
} from '@trevor/ui-components';
import { useDispatch } from 'react-redux';
import { RESET_LAYER_IN_EDIT_MODE } from '@/actions/constants';

export const SavedQueryButton: TrevorComponent<{
  isExistingLayer?: boolean;
}> = ({ children, className, isExistingLayer }) => {
  const dispatch = useDispatch();
  const { toggle } = useDropdown();

  const handleClose = () => {
    if (isExistingLayer) {
      dispatch({ type: RESET_LAYER_IN_EDIT_MODE });
      toggle();
    }
  };

  return (
    <button className={className} onClick={handleClose}>
      {children}
      <TrevorIcon name="chevron-down" size={8} />
    </button>
  );
};
